import "./style.scoped.scss";

import clsx from "clsx";
import { useLoader } from '../../repositories/clients/LoaderContext';

export default function LoaderBar({ disabled }) {

    const { loading } = useLoader();

    if (disabled) return null

    return (

        <div className={clsx(
            "loader-bar",
            { "active": loading || false /* true = debug*/ })}>

            <div className="line"></div>
            <div className="subline inc"></div>
            <div className="subline dec"></div>
        </div>
    )
}